import { api } from "./NetworkBase";

export async function GetUsers(filter) {
	let response = await api
		.get("scannerapp/users?filter=" + encodeURI(filter))
		.json();

	return response;
}


export async function AuthenticateUser(username, password) {
	try {
		const response = await api.post("users/authenticate", {
			headers: {
				Authorization: "Basic " + btoa(username + ":" + password),
			},
		}).json()
		if(response.status!==200){
			SetLoggedInUser(response);			
		}
		return response;
	} catch (error) {		
		throw new Error("Failed to authenticate user.");
	}
}

export async function ResetPasswordRequest(accountOrEmail) {
	try {
		const response = await api.post("users/reset-password-request?email="+ encodeURI(accountOrEmail), {			
		}).json()		
		return response;
	} catch (error) {		
		throw new Error("Error.");
	}
}

export async function ResetPasswordResponse(model) {
	try {
		const response = await api.post("users/reset-password-response", {		
			json: model	
		}).json()		
		return response;
	} catch (error) {		
		throw new Error("Error.",error);
	}
}

export async function UpdateUserName(dto) {
	try {
		let response = await api
		  .put(`users/user-name`, {
			json: dto,
		  })
		  .json();
		return response;
	  } catch (error) {
		throw error;
	  }
}

export async function UpdateUserPassword(dto) {
	try {
		let response = await api
		  .put(`users/update-password`, {
			json: dto,
		  })
		  .json();
		return response;
	  } catch (error) {
		throw error;
	  }
}
export async function GetEtkKits() {
	let response = await api
		.get("scannerapp/etk-kits")
		.json();

	return response;
}

export async function GetLastUser() {
	let localItem = localStorage["lastUser"];

	if (localItem) {
		return localItem;
	}
}

export async function SetLastUser(user) {
	localStorage.setItem("lastUser", user);
}


export async function GetLoggedInUser() {
	const loggedInUser = localStorage.getItem("loggedInUser");	
    const userObject = JSON.parse(loggedInUser);
	if (userObject) {
		return userObject;
	}
}

export async function SetLoggedInUser(user) {
	try {
	  const userJson = JSON.stringify(user);
	  localStorage.setItem("loggedInUser", userJson);
	} catch (error) {
	  console.error("Failed to set loggedInUser in local storage:", error);
	}
}

export async function LogoutUser() {
	try {
		await api.post("users/logout");
	} catch {
		// Proceed with local cleanup even if the backend call fails
	}
}

